'use client';

import { useEffect } from 'react';
import { useSession, oneTap } from '@/lib/auth-client';
import { AnalyticsService } from '@/_services/analytics.service.client';

export default function OneTapLogin() {
	const { data: session, isPending } = useSession();

	useEffect(() => {
		if (isPending || session) return;

		// Deferred to avoid FedCM AbortError from React strict mode's double-mount cycle.
		const timer = setTimeout(() => {
			oneTap({
				fetchOptions: {
					onSuccess: () => {
						AnalyticsService.userSignedUp({ source: 'google_one_tap' });
						window.location.reload();
					}
				}
			});
		}, 100);

		return () => {
			clearTimeout(timer);
		};
	}, [isPending, session]);

	return null;
}
